export class Region {
  id?: string;
  name?: string;
  descr?:string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/region.ts